import { useEffect, useState } from "react";
import { Check, LayoutDashboard, X, ArrowRight } from "lucide-react";

const MEI_MASTER_URL = "https://go.hotmart.com/R107350370O";
const STORAGE_KEY = "mei-master-article-banner-closed";

const FEATURES = [
  "Faturamento e limite anual",
  "DAS e despesas",
  "Notas fiscais",
  "Dashboard + checklist",
];

export function ArticleMeiMasterBanner() {
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    try {
      const wasClosed = localStorage.getItem(STORAGE_KEY) === "1";
      if (!wasClosed) {
        const timer = window.setTimeout(() => setVisible(true), 3000);
        return () => window.clearTimeout(timer);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    setClosed(true);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // ignore
    }
  };

  if (closed || !visible) return null;

  return (
    <aside
      role="complementary"
      aria-label="MEI Master OS"
      className="fixed bottom-0 left-0 right-0 z-[80] border-t border-border bg-card/95 backdrop-blur-md shadow-[0_-8px_30px_rgba(0,0,0,0.12)] p-4 sm:p-5"
    >
      <div className="container mx-auto max-w-5xl">
        <div className="mei-master-banner relative flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-2xl border border-border bg-surface p-4 sm:p-5">
          <button
            type="button"
            onClick={handleClose}
            aria-label="Fechar banner"
            className="absolute -top-2 -right-2 flex h-7 w-7 items-center justify-center rounded-full bg-muted text-muted-foreground hover:bg-accent hover:text-accent-foreground border border-border shadow-sm transition"
          >
            <X className="h-3.5 w-3.5" />
          </button>

          <div className="flex flex-1 flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <LayoutDashboard className="h-6 w-6" />
            </div>

            <div className="flex-1 min-w-0">
              <div className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-widest text-primary">
                ✦ Novo para MEI
              </div>
              <h3 className="mt-1 font-display text-xl sm:text-2xl font-extrabold leading-tight text-foreground">
                Organize seu MEI em um só lugar
              </h3>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Controle faturamento, DAS, notas fiscais, despesas e obrigações de forma organizada.
              </p>

              <ul className="mt-2 hidden sm:flex flex-wrap gap-x-4 gap-y-1">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-center gap-1.5 text-xs font-semibold text-foreground">
                    <Check className="h-3.5 w-3.5 shrink-0 text-primary" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex w-full sm:w-auto flex-col items-start sm:items-end gap-2 sm:pl-4 sm:border-l sm:border-border">
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <LayoutDashboard className="h-4.5 w-4.5" />
              </div>
              <div>
                <div className="text-xs font-bold text-foreground leading-none">MEI Master OS</div>
                <div className="text-[10px] text-muted-foreground leading-none mt-0.5">Sistema completo no Notion</div>
              </div>
            </div>

            <div className="text-right">
              <div className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Acesso completo</div>
              <div className="font-display text-3xl font-extrabold text-foreground leading-none">
                <span className="align-top text-base">R$</span>67<span className="text-base">,00</span>
              </div>
            </div>

            <a
              href={MEI_MASTER_URL}
              target="_blank"
              rel="sponsored noopener noreferrer"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-cta px-5 py-2.5 text-sm font-bold text-cta-foreground shadow-lg hover:brightness-95 transition min-h-10"
            >
              Quero conhecer <ArrowRight className="h-4 w-4" />
            </a>

            <div className="flex items-center gap-1 text-[10px] text-muted-foreground">
              <span aria-hidden>🔒</span> Pagamento seguro via Hotmart
            </div>
          </div>
        </div>

        <p className="mt-2 text-[10px] text-center text-muted-foreground">
          Ferramenta de organização para MEI. Não substitui orientação contábil profissional.
        </p>
      </div>
    </aside>
  );
}
